// extracted by mini-css-extract-plugin
export default {"header":"header_header__zhJh1","links":"header_links__7dROP"};